/**
 * @param {Array<Record<string, unknown>>} rows
 * @param {string} labelKey
 * @param {string} valueKey
 * @returns {Record<string, number>}
 */
export const rowsToBarChartData = (rows, labelKey, valueKey) => {
  const result = {};
  if (!Array.isArray(rows)) return result;

  rows.forEach((row, idx) => {
    let label = row?.[labelKey];
    if (label == null || String(label).trim() === '') {
      label = `Item ${idx + 1}`;
    }
    label = String(label);
    const v = Number(row?.[valueKey]);
    if (!Number.isFinite(v)) return;

    let key = label;
    if (Object.prototype.hasOwnProperty.call(result, key)) {
      const suffix = row?.campaign_id ?? row?.channel_id ?? row?.country_code ?? row?.domain ?? idx;
      key = `${label} (${suffix})`;
    }
    result[key] = v;
  });

  return result;
};
